import { atomWithStorage } from "jotai/utils";
import { omniStorage } from "src/utils/atoms";
import type { Locale } from "./types";

export const localeAtom = atomWithStorage<Locale>("omni-locale", "en", omniStorage<Locale>());
localeAtom.debugLabel = "i18n/locale";
